import React from 'react'
import "./terms.css"

const Terms = () => {
  return (
    <>
        <div className='gradient2'></div>
    <section className="terms-section">
    <div class="faq">
        <div class="faq-left-desktop">
            <div class="faq-left-image-desktop">
                <img className='terms-image' src="https://rvs-faq-accordion-card.netlify.app/images/illustration-woman-online-desktop.svg" alt="illustration-woman-online-desktop"/>
            </div>
            <img className='terms-image' src="https://rvs-faq-accordion-card.netlify.app/images/illustration-box-desktop.svg" alt="illustration-box-desktop"/>
        </div>
        <div class="faq-left-mobile">
            <div class="faq-left-image-mobile">
                <img className='terms-image' src="https://rvs-faq-accordion-card.netlify.app/images/illustration-woman-online-mobile.svg" alt="illustration-woman-online-mobile"/>
            </div>
        </div>
        <div class="faq-right">
            <div class="faq-title">FAQ</div>
            <div class="faq-body">
                <details>
                    <summary>How many team members can I invite?</summary>
                    <p>You can invite up to 2 additional users on the Free plan. There is no limit on team members for the Premium plan.</p>
                </details>
                <details>
                    <summary>What is the maximum file upload size?</summary>
                    <p>No more than 2GB. All files in your account must fit your allotted storage space.</p>
                </details>
                <details>
                    <summary>How do I reset my password?</summary>
                    <p>Click “Forgot password” from the login page or “Change password” from your profile page. A reset link will be emailed to you.</p>
                </details>
                <details>
                    <summary>Can I cancel my subscription?</summary>
                    <p>Yes! Send us a message and we’ll process your request no questions asked.</p>
                </details>
                <details>
                    <summary>Do you provide additional support?</summary>
                    <p>Chat and email support is available 24/7. Phone lines are open during normal business hours.</p>
                </details>
            </div>
        </div>
    </div>
</section>
    </>
  )
}

export default Terms

